import { useEffect, useRef, useState } from "react";

/**
 * Animates a number from 0 to `value` in `duration` ms.
 * Non-numeric values are returned as-is.
 */
export default function CountUp({ value, duration = 900, className = "", suffix = "" }) {
  const [display, setDisplay] = useState(0);
  const rafRef = useRef();
  const startTsRef = useRef();

  const numeric = typeof value === "number" && !Number.isNaN(value);

  useEffect(() => {
    if (!numeric) {
      setDisplay(value);
      return undefined;
    }
    setDisplay(0);
    startTsRef.current = undefined;

    const step = (ts) => {
      if (!startTsRef.current) startTsRef.current = ts;
      const progress = Math.min(1, (ts - startTsRef.current) / duration);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.round(value * eased));
      if (progress < 1) rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => rafRef.current && cancelAnimationFrame(rafRef.current);
  }, [value, duration, numeric]);

  return (
    <span className={className}>
      {numeric ? display.toLocaleString() : value}
      {suffix}
    </span>
  );
}
